import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import axiosInstance, { API_ENDPOINTS, HOST_API } from '../axios/axiosInstance';

const TabelaAlergenos = () => {
  const { t, i18n } = useTranslation();
  const [allergens, setAllergens] = useState([]);

  useEffect(() => {
    const fetchAllergens = async () => {
      try {
        const res = await axiosInstance.get(HOST_API + API_ENDPOINTS.allergen);
        setAllergens(res.data);
      } catch (error) {
        console.error('Error fetching allergens:', error);
      }
    };
    fetchAllergens();
  }, []);

  const getAllergenName = (allergen) => {
    const lang = i18n.language || 'pt';
    switch (lang) {
      case 'en': return allergen.englishName || allergen.portugueseName;
      case 'fr': return allergen.frenchName || allergen.portugueseName;
      default: return allergen.portugueseName;
    }
  };

  // Split allergens into 3 columns (already sorted by order from API)
  const getColumns = () => {
    if (allergens.length === 0) return [[], [], []];
    const itemsPerColumn = Math.ceil(allergens.length / 3);
    return [
      allergens.slice(0, itemsPerColumn),
      allergens.slice(itemsPerColumn, itemsPerColumn * 2),
      allergens.slice(itemsPerColumn * 2)
    ];
  };

  const columns = getColumns();

  if (allergens.length === 0) {
    return null;
  }

  return (
    <div style={styles.tabelaAlergenos}>
      <h3 className='menu-item-name' style={styles.titulo}>
        {t('allergens.title')} <br /> {t('allergens.subtitle')}
      </h3>
      <div className='menu-item-name' style={styles.alergenosLista}>
        {columns.map((column, colIndex) => (
          <div key={colIndex} className='menu-item-name' style={styles.coluna}>
            {column.map((allergen, index) => (
              <span key={allergen.id}>
                ({allergen.order}) {getAllergenName(allergen)}
                {index < column.length - 1 && <br />}
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  tabelaAlergenos: {
    width: '80%',
    margin: '20px auto',
    lineHeight: '2',
    textAlign: 'center',
  },
  titulo: {
    fontSize: '20px',
    fontWeight: 'normal',
    marginBottom: '10px',
  },
  alergenosLista: {
    display: 'flex',
    justifyContent: 'space-around',
    flexWrap: 'wrap',
  },
  coluna: {
    flex: 1,
    minWidth: '200px',
    textAlign: 'left',
  },
};

export default TabelaAlergenos;
